import React from "react";
import { useTranslation } from 'react-i18next';

const Loader = () => {
  const { t } = useTranslation();

  return (
    <div className="backdrop">
    <main>
      <div className="ship">
        <img src="/media/loader.gif" alt="logo" className="loader-logo" style={{width:120,height:120,objectFit:'contain'}}/>
        {/* ...existing svg removed for brevity... */}
        <p className="text-white fs-6">{t('loader.loading', 'Loading, please wait...')}</p>
      </div>
    </main>
    </div>
  );
};

export default Loader;
